const SCHEDULE_TIMEZONE = "America/Sao_Paulo";

const OFFSET_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i;

const pad = value => String(value).padStart(2, "0");

const parseWallClockString = value => {
  if (typeof value !== "string") return null;

  const match = value.match(
    /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?/
  );

  if (!match) return null;

  const [, year, month, day, hour, minute, second = "0"] = match;
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  );
};

const getTimeZoneParts = date => {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: SCHEDULE_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    hourCycle: "h23"
  });

  return formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== "literal") acc[part.type] = part.value;
    return acc;
  }, {});
};

export const scheduleDateToCalendarDate = value => {
  if (!value) return new Date("");

  if (typeof value === "string" && !OFFSET_PATTERN.test(value)) {
    return parseWallClockString(value) || new Date(value);
  }

  const instant = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(instant.getTime())) return instant;

  const parts = getTimeZoneParts(instant);
  return new Date(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second || 0)
  );
};

export const scheduleDateToDatetimeLocal = value => {
  const date = scheduleDateToCalendarDate(value);
  if (Number.isNaN(date.getTime())) return "";

  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate())
  ].join("-") + `T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatScheduleTime = value => {
  const date = scheduleDateToCalendarDate(value);
  if (Number.isNaN(date.getTime())) return "";

  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatCalendarTime = date => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
